export default "assets/marker-c4e7d80c.svg";